import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Save, MoreHorizontal } from "lucide-react";
import { SaveMessageDialog } from "./SaveMessageDialog";

interface MessageActionsPopoverProps {
	messageData: {
		id?: string; // Add message ID for duplicate prevention
		text: string;
		subject?: string;
		messageType?: string;
		participants?: any;
	};
	currentEntity?: {
		type: 'candidates' | 'jobs' | 'companies';
		id: string;
		name?: string;
	};
	onMessageSaved?: () => void;
	children?: React.ReactNode;
}

export const MessageActionsPopover: React.FC<MessageActionsPopoverProps> = ({
	messageData,
	currentEntity,
	onMessageSaved,
	children
}) => {
	const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);

	const handleSaveClick = () => {
		setIsSaveDialogOpen(true);
	};

	const handleMessageSaved = () => {
		onMessageSaved?.();
		setIsSaveDialogOpen(false);
	};

	return (
		<>
			{children ? (
				<div onClick={handleSaveClick}>
					{children}
				</div>
			) : (
				<Button
					variant="ghost"
					size="sm"
					className="opacity-0 group-hover:opacity-100 transition-opacity"
					onClick={handleSaveClick}
				>
					<Save className="h-4 w-4" />
				</Button>
			)}

			<SaveMessageDialog
				isOpen={isSaveDialogOpen}
				onClose={() => setIsSaveDialogOpen(false)}
				messageData={messageData}
				currentEntity={currentEntity}
				onMessageSaved={handleMessageSaved}
			/>
		</>
	);
};
